import { render, staticRenderFns } from "./PropertiesView.vue?vue&type=template&id=3cf6fdf0&lang=pug&"
import script from "./PropertiesView.vue?vue&type=script&lang=ts&"
export * from "./PropertiesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports